import { render, staticRenderFns } from "./Evento_pais_live.vue?vue&type=template&id=6a916a1e&scoped=true&"
import script from "./Evento_pais_live.vue?vue&type=script&lang=js&"
export * from "./Evento_pais_live.vue?vue&type=script&lang=js&"
import style0 from "./Evento_pais_live.vue?vue&type=style&index=0&id=6a916a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a916a1e",
  null
  
)

export default component.exports